import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackCopyWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackCopyWishList";

const useTrackCopyWishList = (
    parameters: TrackCopyWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.copyWishList, parameters, options);
};

export default useTrackCopyWishList;
